<template>
  <QCard
    :class="{ 'full-width': $q.screen.lt.md }"
    class="column q-pa-lg q-ma-md"
  >
    <PageHeader class="q-pb-md">
      <div class="col-12 q-mb-xs">
        <HeaderBackBtn @click="$emit('back', $event)" />
      </div>
      <h4 class="col-12">Welcome Back {{ firstName }} {{ lastName }}</h4>
    </PageHeader>
    <p class="q-mt-md">
      It looks like you have tried to create a Novated account, but already have
      one setup.
    </p>
    <p>Follow the link below to log in.</p>
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        label="Log In"
        no-caps
        padding="12px xl"
        @click="$emit('logIn')"
      />
    </div>
  </QCard>
</template>

<script>
import { QCard } from 'quasar';
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'AccountExists',
  props: {
    firstName: String,
    lastName: String
  },
  components: {
    QCard,
    SAIBtn,
    HeaderBackBtn: () => import('../../atom/header-back-btn'),
    PageHeader: () => import('../../atom/page-header')
  }
};
</script>
